import { numFormat } from './numFormat';

export function currency(value: number, currency?: string) {
  const formattedValue = numFormat(value);
  return formattedValue !== value ?  `${currency ? currency : 'SAR'} ${formattedValue}` : value;
}

const th = ['', 'thousand', 'million', 'billion', 'trillion'];
const dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']; 
const tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
const tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

function firstLetterUppercase(s: string) {
  if (typeof s !== 'string') return ''
  return s.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function currencyToWords(value: number) {
  const [wholeNumber, decimal] = value.toFixed(2).split('.');
  const currencyToWords = (s: string) => {
    s = s.replace(/[\\, ]/g, '');
    if (Number(s) != parseFloat(s)) {
      return 'not a number';
    }
    let x = s.indexOf('.');
    if (x == -1) {
      x = s.length;
    }
    if (x > 15) {
      return 'too big';
    }
    const n = s.split('');
    let str = '';
    let sk = 0;
    for (let i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == '1') {
          str += tn[Number(n[i + 1])] + ' ';
          i++;
          sk = 1;
        } else if (Number(n[i]) != 0) {
          str += tw[Number(n[i]) - 2] + ' ';
          sk = 1;
        }
      } else if (Number(n[i]) != 0) {
        str += dg[Number(n[i])] + ' ';
        if ((x - i) % 3 == 0) {
          str += 'hundred ';
        }
        sk = 1;
      }
      if ((x - i) % 3 == 1) {
        if (sk) {
          str += th[(x - i - 1) / 3] + ', ';
        }
        sk = 0;
      }
    }
    if (x != s.length) {
      const y = s.length;
      str += 'point ';
      for (let i = x + 1; i < y; i++) {
        str += dg[Number(n[i])] + ' ';
      }
    }
    str = str.replace(/,\s$/, '');
    return str.replace(/\s+/g, ' ');
  };
  const wholeNumberInWords = currencyToWords(wholeNumber);
  const decimalInWords = currencyToWords(decimal);
  let outputcurrencyInWords = `${wholeNumberInWords} Saudi Riyal`;
  if (decimalInWords) {
    outputcurrencyInWords = `${outputcurrencyInWords} and ${decimalInWords} Halala`;
  }
  return firstLetterUppercase(`${outputcurrencyInWords} Only`);
}